<app-page-content [showSearchBox]="true" (search)="search()" [(searchQuery)]="searchQuery" [useMobileHeaderColors]="true" *ngIf="!session.isValid()">
  <app-button-box pageheaderactions>
    <button mat-icon-button style="color: white" (click)="login()">
      <mat-icon>lock</mat-icon>
    </button>
  </app-button-box>

  <div style="display: flex; flex-direction: row; align-items: center" pagetitle>
    <svg style="margin-right: 0.3em; width:36px;height:36px" viewBox="0 0 24 24">
      <path fill="#FFFFFF"
            d="M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z"/>
    </svg>
    TaskR - sporing
  </div>

  <div pagecontent>
    <div style="display: flex; flex-direction: row" *ngIf="shipment !== undefined">
      <div style="flex: 1 1 auto">&nbsp;</div>
      <div class="container">
        <div style="display: flex; flex-direction: column; flex: 1 1 30%; max-width: 30%">
          <app-expand-panel title="Sendingsinformasjon">
            <div style="display: flex; flex-direction: column; padding: 0 1em 0 1em;">
              <app-field title="Status"><span>{{shipment | shipmentStatusName}}</span></app-field>
              <app-field title="Antall kolli"><span>{{shipment.Parcels.length}}</span></app-field>
              <app-field title="Registrert"><span>{{shipment.CreatedAt | date:'dd.MM.yy HH:mm'}}</span></app-field>
              <app-field title="Ekstern sporing" *ngIf="shipment.ExternalTrackingUrl !== null">
                <a href="{{shipment.ExternalTrackingUrl}}">{{shipment.ExternalTrackingUrl}}</a>
              </app-field>
            </div>
          </app-expand-panel>
          <app-expand-panel title="Avsender">
            <div style="display: flex; flex-direction: column; padding: 0 1em 0 1.3em;">
              <span>{{shipment.Sender.PostCode}} {{shipment.Sender.City}}</span>
            </div>
          </app-expand-panel>
          <app-expand-panel title="Mottaker">
            <div style="display: flex; flex-direction: column;padding: 0 1em 0 1.3em;">
              <span>{{shipment.Receiver.PostCode}} {{shipment.Receiver.City}}</span>
            </div>
          </app-expand-panel>
        </div>
        <app-expand-panel title="Hendelser" style="flex: 1 1 auto">
          <div *ngIf="getEvents().length == 0" style="margin: 0 1em 0 1em">Ingen hendelser</div>
          <div *ngIf="getEvents().length > 0" style="border-color: #ddd; border-width: 1px 1px 0 1px; border-style: solid; margin: 0 1em 0 1em">
            <div style="background-color: #fdfdfd; border-color: #ddd; border-width: 0 0 1px 0; border-style: solid; padding: 0.5em" *ngFor="let event of getEvents()">
              <div style="display: flex; flex-direction: row; margin-bottom: 0.5em">
                <span style="font-weight: normal;">{{event.number}}</span>
                <span style="flex: 1 1 auto;"></span>
                <span>{{event.createdAt | date:'dd.MM.yy HH:mm'}}</span>
              </div>
              <div style="margin-bottom: 0.5em">
                <span>{{event.name}}</span>
              </div>
            </div>
          </div>
        </app-expand-panel>
      </div>
      <div style="flex: 1 1 auto">&nbsp;</div>
    </div>
    <app-error *ngIf="error !== null" [icon]="error.error.icon" [description]="error.error.errorMessage"
               [css_class]="error.error.css_class" [code]="error.status"></app-error>
  </div>
</app-page-content>

